import React from "react";
import { BuildingApartment } from "@phosphor-icons/react";

export const Logo = ({ size = 28, showText = true, className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-logo">
      <div
        className="flex items-center justify-center rounded-md"
        style={{ width: size + 10, height: size + 10, background: "#1B4332" }}
      >
        <BuildingApartment size={size} weight="duotone" color="#F9F8F6" />
      </div>
      {showText && (
        <div className="leading-none">
          <div className="font-heading font-semibold text-stone-900 text-lg tracking-tight">
            rentmore<span className="text-terra-500">24</span>
          </div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-stone-400">
            AI Leasing Agent
          </div>
        </div>
      )}
    </div>
  );
};

export default Logo;
